import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import moment from "moment";
require('moment/locale/fr')

import "./index.css";
import "tabulator-tables/dist/css/tabulator_bootstrap4.min.css";
import "./css/tabulator.css";
import "./css/b-table.css";
import "./css/jsoneditor.css";
import "./css/cascader-select.css";
import "./css/autocomplete.css";
import "./css/querybuilder.css";

import Autocomplete from "@trevoreyre/autocomplete-vue";
// import '@trevoreyre/autocomplete-vue/dist/style.css'

import "ace-builds/webpack-resolver";

import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import "./sass/sparkle.scss";
import "./sass/auth.scss";

import VueSidebarMenu from "vue-sidebar-menu";
import "vue-sidebar-menu/dist/vue-sidebar-menu.css";

import VueSimpleMarkdown from "vue-simple-markdown";
import "vue-simple-markdown/dist/vue-simple-markdown.css";

import LoadScript from "vue-plugin-load-script";

import Notifications from "vue-notification";

import VuePapaParse from "vue-papa-parse";

import VueObserveVisibility from "vue-observe-visibility";

import UUID from "vue-uuid";

import VueSimpleAlert from "vue-simple-alert";

import panZoom from "vue-panzoom";

Vue.prototype.moment = moment;

import VCalendar from 'v-calendar';

import { VueReCaptcha } from 'vue-recaptcha-v3'

if (process.env.VUE_APP_RECAPTCHA)
{
    Vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_RECAPTCHA,  loaderOptions: { autoHideBadge: true }})
}

import vSelect from 'vue-select'
Vue.component('v-select', vSelect)
import 'vue-select/dist/vue-select.css';

import cronLight from '@vue-js-cron/light'
import '@vue-js-cron/light/dist/light.css'
Vue.use(cronLight)

import VueSocketIO from 'vue-socket.io'
Vue.use(new VueSocketIO({
    debug: false,
    connection: `${process.env.VUE_APP_SAAS_BACK}`,
    vuex: {
        store,
        actionPrefix: 'SOCKET_',
        mutationPrefix: 'SOCKET_'
    },
    options: { } //Optional options
}))

Vue.use(VueSimpleAlert);
Vue.use(VueSidebarMenu);
Vue.use(VueSimpleMarkdown);
Vue.use(BootstrapVue);
Vue.use(LoadScript);
Vue.use(VuePapaParse);
Vue.use(VueObserveVisibility);
Vue.use(Notifications);
Vue.use(panZoom);
Vue.use(UUID);
Vue.use(Autocomplete);

Vue.use(VCalendar);

Vue.use(require('vue-moment'), {
    moment
})

Vue.config.productionTip = false;

import create from "./views/Create.vue";
Vue.component("create", create)

import treatment from "./components/treatment.vue";
Vue.component("treatment", treatment)

import treatment_selector from "./components/treatment_selector.vue";
Vue.component("treatment_selector", treatment_selector)

import data_component from "./components/data.vue";
Vue.component("data_component", data_component)

import validation from "./views/Validation.vue";
Vue.component("validation", validation)

import database from "./views/database.vue";
Vue.component("database", database)

import step_workflow from "./components/step_workflow.vue";
Vue.component("step_workflow", step_workflow)

import contenteditable from 'vue-contenteditable'
Vue.use(contenteditable)

new Vue({
    sockets: {
        connect: function () {
            //console.log('socket connected')
            //console.log(this.$socket.id)
        },
        error: function(err)
        {
            //this.$store.commit("setBack", false);
        },
        disconnect: function()
        {
            //this.$store.commit("setBack", false);
        },
        reconnect: function()
        {
            //this.$store.commit("setBack", true);
        }
	},
	router,
	store,
	render: (h) => h(App),
}).$mount("#app");
